/**
 * Report graph colours, resolved by what a series represents rather than by its
 * position in the chart. Values come from the shared monitoring palette so the
 * report and the monitoring page stay aligned.
 */
import {
  LABEL_TEXT_COLOR,
  PHASE_COLORS,
  SEMANTIC_COLORS,
} from "../monitoring/builders/2.0.0/graphs/graphColors"

export { LABEL_TEXT_COLOR, PHASE_COLORS, SEMANTIC_COLORS }

/** Fallback cycle for series with no semantic colour (e.g. tank level). */
export const FALLBACK_SERIES_COLORS = ["#39aed2", "#7cc9a6", "#f2b134", "#c98bd0", "#e07a5f"] as const

/** Series key → semantic colour. */
const SERIES_KEY_COLORS: Record<string, string> = {
  energy: SEMANTIC_COLORS.siteProfile,
  power: SEMANTIC_COLORS.siteProfile,
  fuel_consumed: SEMANTIC_COLORS.fuel,
  // Diesel tank level is fuel too. Water / waste levels keep the fallback cycle
  // so grouped tank bars stay distinguishable.
  diesel_level: SEMANTIC_COLORS.fuel,
  engine_hours: SEMANTIC_COLORS.generator,
  battery_only_hours: SEMANTIC_COLORS.battery,
  phase_share_l1: PHASE_COLORS.l1,
  phase_share_l2: PHASE_COLORS.l2,
  phase_share_l3: PHASE_COLORS.l3,
  genset_phase_share_l1: PHASE_COLORS.l1,
  genset_phase_share_l2: PHASE_COLORS.l2,
  genset_phase_share_l3: PHASE_COLORS.l3,
}

/** Colour for a report series: its semantic colour, else the index-based fallback. */
export function colorForSeries(key: string, index: number): string {
  return SERIES_KEY_COLORS[key] ?? FALLBACK_SERIES_COLORS[index % FALLBACK_SERIES_COLORS.length]
}
